// fileManagerService.js
import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const fileManagerService = {
  async uploadFile(formData) {
    try {
      const response = await api_fetch.postForm(
        '/v1/upload-file', // Your backend file upload endpoint
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}` // Include authorization token
        },
        {},
        '',
        formData
      );

      const responseJson = await response.json(); // Parse the JSON response
      return responseJson;
    } catch (error) {
      console.error('Upload error:', error);
      throw new Error('File upload failed.');
    }
  },

  getFiles: async function () {
    return (
      await api_fetch.get(
        `/v1/file-manager/get-files`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async downloadFile(fileUrl) {
    return await api_fetch.get(
      `/v1/file-manager/download-file/${fileUrl}`,
      {},
      {}
    );
  },

  async downloadAndSaveFile(imageUrl) {
    try {
      const urlObj = new URL(imageUrl);
      const s3Key = decodeURIComponent(urlObj.pathname.slice(1)); // e.g. 'uploads/image.jpg'
      const encodedKey = encodeURIComponent(s3Key);

      const res = await this.downloadFile(encodedKey);

      if (!res.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await res.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = s3Key.split('/').pop(); // Use filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download error:', error);
      throw error; // Let the component handle alerting
    }
  }
};

export default fileManagerService;
